module.exports = __webpack_public_path__ + "3382502c6aa09258c210415dbe33dc57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/22_CC_V_BoulderCar.png
// module id = 123
// module chunks = 0